/* tslint:disable */
/* eslint-disable */
/**
 * crm
 * crm
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResolveDuplicateResidentListEntry } from './ResolveDuplicateResidentListEntry';
import {
    ResolveDuplicateResidentListEntryFromJSON,
    ResolveDuplicateResidentListEntryFromJSONTyped,
    ResolveDuplicateResidentListEntryToJSON,
} from './ResolveDuplicateResidentListEntry';

/**
 * 
 * @export
 * @interface ResolveDuplicatesRequest
 */
export interface ResolveDuplicatesRequest {
    /**
     * 
     * @type {string}
     * @memberof ResolveDuplicatesRequest
     */
    primary_prospect_id: string;
    /**
     * 
     * @type {Array<ResolveDuplicateResidentListEntry>}
     * @memberof ResolveDuplicatesRequest
     */
    prospects: Array<ResolveDuplicateResidentListEntry>;
}

/**
 * Check if a given object implements the ResolveDuplicatesRequest interface.
 */
export function instanceOfResolveDuplicatesRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "primary_prospect_id" in value;
    isInstance = isInstance && "prospects" in value;

    return isInstance;
}

export function ResolveDuplicatesRequestFromJSON(json: any): ResolveDuplicatesRequest {
    return ResolveDuplicatesRequestFromJSONTyped(json, false);
}

export function ResolveDuplicatesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResolveDuplicatesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'primary_prospect_id': json['primary_prospect_id'],
        'prospects': ((json['prospects'] as Array<any>).map(ResolveDuplicateResidentListEntryFromJSON)),
    };
}

export function ResolveDuplicatesRequestToJSON(value?: ResolveDuplicatesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'primary_prospect_id': value.primary_prospect_id,
        'prospects': ((value.prospects as Array<any>).map(ResolveDuplicateResidentListEntryToJSON)),
    };
}

